/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import SearchBox from 'components/form/searchBox';
import PanelBoxLayout from 'components/layout/panelBox';
import Toolbar from 'components/toolbar';
// import PaginationApp from "components/pagination";
import { useActions } from 'common/hooks/useActions';
import RowAction from 'components/rowAction';
import QuestionModal from 'components/modal/question';
import AppTreeTable from 'components/appTreeTable';
import Thumb from 'components/thumb';
import Empty from 'components/empty';
import Value from 'components/value';
import { ReactSVG } from 'react-svg';

import * as S from './styles';
import * as T from 'common/types';

const PenIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
  </svg>
);

const TagIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z" />
    <path d="M7.5 7.5h.01" />
  </svg>
);

interface IProps {
  data: [];
  loading: boolean;
}

export default function CategoriesTable({ data, loading }: IProps) {
  const { ticketCategoriesRequestAction, ticketCategoryDeleteRequestAction, ticketCategoryEnableRequestAction } =
    useActions();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showEnableModal, setShowEnableModal] = useState<boolean>(false);
  const [disableData, setDisableData] = useState<T.Pages.Category | null>(null);
  const [expandedItems, setExpandedItems] = useState<number[]>([]);
  const [enableData, setEnableData] = useState<T.Pages.Category | null>(null);

  const [meta, setMeta] = useState({
    query: '',
    type: ''
  });

  const fetchData = () => {
    ticketCategoriesRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  // kept for the disable-category modal below; its trigger button is currently commented out
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleShowDisableModal = (data: T.Pages.Category) => {
    setShowDeleteModal(true);
    setDisableData(data);
  };

  const handleCloseDisableModal = () => {
    setShowDeleteModal(false);
    setDisableData(null);
  };

  const handleDisableCategory = () => {
    ticketCategoryDeleteRequestAction({ id: disableData?.id }, () => {
      handleCloseDisableModal();
      // fetchData();
      window.location.reload();
    });
  };

  // kept for the enable-category modal below; its trigger button is currently commented out
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleShowEnableModal = (data: T.Pages.Category) => {
    setShowEnableModal(true);
    setEnableData(data);
  };

  const handleCloseEnableModal = () => {
    setShowEnableModal(false);
    setEnableData(null);
  };

  const handleEnableCategory = () => {
    ticketCategoryEnableRequestAction({ id: enableData?.id }, () => {
      handleCloseEnableModal();
      // fetchData();
      window.location.reload();
    });
  };

  return (
    <S.Content>
      <PanelBoxLayout className="flush" contentStyle={{ padding: 0 }}>
        <Toolbar>
          <SearchBox
            onChange={(e) => setMeta({ ...meta, query: e })}
            placeholder="Search categories"
            value={meta.query}
          />
        </Toolbar>
        <AppTreeTable
          headers={[
            { id: 1, key: 'id', title: 'ID', dir: 'left', width: 84 },
            { id: 2, key: 'icon', title: 'Icon', width: 72 },
            { id: 4, key: 'title', title: 'Title', dir: 'left' },
            { id: 6, key: 'management', title: '', type: 'actions', width: 64 }
          ]}
          empty={
            <Empty
              icon={<TagIcon />}
              title={meta.query ? `No categories match “${meta.query}”` : 'No categories yet'}
              text={
                meta.query
                  ? 'Check the spelling, or clear the search.'
                  : 'Create a category and it appears here, with its sub-categories beneath it.'
              }
            />
          }
          style={{ minWidth: 'auto' }}
          loading={loading}
          data={data}
          altanfeethiFields={{
            id: (item: T.Pages.Category) => (
              <S.Div className="text-left">
                <Value mono>{item?.id}</Value>
              </S.Div>
            ),
            icon: (item: T.Pages.Category) => (
              <S.Div className="flex-center">
                <Thumb src={item.icon} name={item.title} />
              </S.Div>
            ),
            title: (item: T.Pages.Category, _child: boolean, hasChildren?: boolean, callBack?: (e: any) => void) => (
              <S.TitleTd
                className={`text-left captal ${_child ? 'child' : ''} ${item.level} ${
                  expandedItems.find((e) => e === item.id) ? 'active' : 'deActive'
                }`}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  if (expandedItems.find((e) => e === item.id))
                    setExpandedItems(expandedItems.filter((e) => e !== item.id));
                  else setExpandedItems([...expandedItems, item.id]);

                  callBack && callBack(item);
                }}
              >
                <S.TitleText>{item.title}</S.TitleText>
                {hasChildren && (
                  <S.ArrowIcon className="child-arrow-icon">
                    <ReactSVG
                      src="/icons/stroke/arrow-bottom.svg"
                      beforeInjection={(svg) => {
                        svg.setAttribute('stroke', 'currentColor');
                      }}
                    />
                  </S.ArrowIcon>
                )}
              </S.TitleTd>
            ),
            management: (item: T.Pages.Category) => (
              <RowAction to={`/panel/ticket/categories/${item.id}`} label={`Edit ${item?.title || 'this category'}`}>
                <PenIcon />
              </RowAction>
            )
          }}
        />
      </PanelBoxLayout>
      {/* {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )} */}

      <QuestionModal
        show={showDeleteModal}
        handleClose={handleCloseDisableModal}
        model="delete"
        title={`Disable ${disableData?.title ?? 'this category'}?`}
        text="Employees stop being able to raise tickets under it. Its sub-categories go with it."
        handleSuccess={handleDisableCategory}
        successButtonText="Disable"
      />

      <QuestionModal
        show={showEnableModal}
        handleClose={handleCloseEnableModal}
        model="success"
        title={`Enable ${enableData?.title ?? 'this category'}?`}
        text="Employees can raise tickets under it again."
        handleSuccess={handleEnableCategory}
        successButtonText="Enable"
      />
    </S.Content>
  );
}
